import { GET_TIMETABLE_SUMMARY } from "@graphql"
import { useQuery } from "@apollo/client"

const useTimetableSummary = (sessionId) => {
  const { data, loading, error, refetch } = useQuery(GET_TIMETABLE_SUMMARY, {
    variables: { 
      input: { id: sessionId },
    },
    skip: !sessionId,
    fetchPolicy: "network-only"
  })

  return {
    data: data?.sessionTimetableSummary || {},
    loading,
    error,
    refetch,
  }
}

export default useTimetableSummary
